import SessionsRequest from '../SessionsRequest';
import Constants from '../../analytics/constants';
import { CoreEvents, ExpireDefault } from '../../common/Constants';
/**
 * Handles expired session recovery and cleanup
 */
export default class ExpirationRecovery {
    constructor(core, coreStorage, expirationManager) {
        this.core = core;
        this.coreStorage = coreStorage;
        this.expirationManager = expirationManager;
    }
    /**
     * Check if session has expired
     */
    hasExpired() {
        return this.expirationManager.isStarted() && this.expirationManager.isExpired();
    }
    /**
     * Recover from expired session
     * Returns a new START request with cleaned params
     * @param lastStartRequest - The last START request (if any)
     * @returns New START request for recovery
     */
    recover(lastStartRequest) {
        // Create START request for recovery
        const start = lastStartRequest ? lastStartRequest : new SessionsRequest(Constants.Service.SESSION_START, {});
        // Remove sessionId, sessionRoot, and beatTime from the start request
        const startParams = Object.assign({}, start.getParams());
        delete startParams.sessionId;
        delete startParams.sessionRoot;
        delete startParams.beatTime;
        start.setParams(startParams);
        // Close the session (cleanup)
        this.closeSession();
        // Schedule SESSION_EXPIRE event
        this.triggerExpireEvent();
        return start;
    }
    /**
     * Close session and cleanup storage
     */
    closeSession() {
        // Reset expiration manager
        this.expirationManager.reset();
        // Remove browser storage
        this.coreStorage.removeStoredData();
        this.coreStorage.removeSession();
        this.coreStorage.removeLastActive();
        // Ask for a new session token
        this.core.refreshSessionToken();
    }
    /**
     * Close the expired session without queueing a recovery START request.
     * Used when sessionRecovery option is 'never' — the host app is expected
     * to start a fresh session itself.
     */
    expireWithoutRecovery() {
        this.closeSession();
        this.triggerExpireEvent();
    }
    /**
     * Trigger SESSION_EXPIRE event after configured delay
     */
    triggerExpireEvent() {
        setTimeout(() => {
            this.core.throwEvent(CoreEvents.SESSION_EXPIRE);
        }, ExpireDefault.STOP_VIEWS_AFTER_SESSION_EXPIRE_MS);
    }
    /**
     * Get expiration manager (for external use)
     */
    getExpirationManager() {
        return this.expirationManager;
    }
}
